import request from './request';
import { API_NEW_USER_INFO } from './api';

export const getUserInfo = () => {
  return request(API_NEW_USER_INFO, {
    method: 'GET',
  })
}